import { useCallback, useEffect, useState } from "react";

// Idioma elegido para el enlace de la galería pública de cada evento ('' = el de cada
// visitante). Lo elige la pestaña Galería pública y lo siguen los botones de la cabecera.
// Vive en memoria: al recargar la página vuelve al globo.
const chosen = new Map();
const listeners = new Set();

export function useGalleryLinkLocale(eventId) {
    const [locale, setLocale] = useState(() => chosen.get(eventId) ?? '');
    useEffect(() => {
        const sync = () => setLocale(chosen.get(eventId) ?? '');
        sync();
        listeners.add(sync);
        return () => { listeners.delete(sync); };
    }, [eventId]);
    const choose = useCallback(next => {
        if (!eventId) return;
        if (next) chosen.set(eventId, next); else chosen.delete(eventId);
        listeners.forEach(listener => listener());
    }, [eventId]);
    return [locale, choose];
}
